import * as React from 'react';

import { Messages } from '../../../../../codegen/Localize';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { ManageUsersSectionProps } from './ManageUsersSection';


export function ManageUsersServerLimitOption(props: ManageUsersSectionProps) {
  const formik = useFormikContext<ManageUsersSectionProps>();

  return <>
    <div>{Messages.serverLimit()}</div>
    {formik.values.settings.userQuotaMode === 'server-limit' && <div>{Messages.serverLimitDescription()}</div>}
  </>;
}
